import PropTypes from 'prop-types';
import CharacterCounter from 'apps/interactions/components/character-counter';
import { useProposalFormContext } from '../context/proposal-form-context';

const TitleField = ({ onChange, onBlur, name = '', value = '', required = false, field, meta, helpers }) => {
  const { standardFieldsConfig } = useProposalFormContext();
  const maxLength = standardFieldsConfig?.title?.max_length;
  return (
    <>
      <input
        id={name}
        type="text"
        name={name}
        value={value || ''}
        placeholder={'Add title...'}
        onChange={onChange}
        onBlur={onBlur}
        // maxLength={maxLength} this seems like the easiest and best way to handle max length validation but :shrug:
      />
      {maxLength && <CharacterCounter limit={maxLength} count={(value || '').length} />}
    </>
  );
};

TitleField.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};

export default TitleField;
